<script lang="ts" setup>
	import { computed } from 'vue'

	import { useAuthStore } from '@/stores'

	import NavbarBrand from './NavbarBrand.vue'
	// import NavbarSearch from './NavbarSearch.vue'
	import NavbarIcons from './NavbarIcons.vue'
	import NavbarMenu from './NavbarMenu.vue'
	import NavbarToggle from './NavbarToggle.vue'

	const authenticated = computed<boolean>(() => {
		return useAuthStore().authenticated
	})
</script>
<template>
	<nav class="px-3 mx-0 navbar navbar-light navbar-glass navbar-top navbar-expand-lg navbar-glass-shadow">
		<NavbarToggle />
		<NavbarBrand />
		<NavbarMenu v-if="authenticated" />
		<!-- <NavbarSearch v-if="authenticated" /> -->
		<NavbarIcons />
	</nav>
</template>
